import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#011523",
      d: "M9.293 13.96 5.04 9.707C4.41 9.077 4.857 8 5.747 8h8.505c.891 0 1.337 1.077.707 1.707l-4.252 4.253a1 1 0 0 1-1.414 0"
    }, null, -1)
  ]))]))
}
export default { render: render }